import * as React from 'react';
import { cn } from '@/shared/lib/cn';
import styles from './Badge.module.css';

export type BadgeVariant = 'default' | 'primary' | 'destructive' | 'success' | 'warning' | 'outline';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  icon?: React.ReactNode;
}

/**
 * Короткая метка рядом с текстом: счётчик, тег, признак вроде «черновик» или
 * «просрочено».
 *
 * Для статуса заявки из флоу есть отдельный StatusBadge — он знает про цвета
 * статусов, Badge про них не знает. Вариант здесь задаёт смысл, а не оттенок:
 * `destructive` про потерю, `warning` про срок, `success` про завершение.
 *
 * Значок идёт слотом `icon`, а не первым ребёнком: у слота свой размер и свой
 * просвет до слова, и ни то, ни другое не задаётся по месту.
 *
 * @use короткая метка рядом с текстом: счётчик, тег, признак вроде «черновик» или «просрочено». Статус заявки из флоу — это StatusBadge.
 */
export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { variant = 'default', icon, className, children, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn(styles.badge, styles[`variant-${variant}`], className)}
      {...rest}
    >
      { }
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      {children}
    </span>
  );
});
